import React, { FC } from 'react'
import { useIntl } from 'react-intl'
import { Text } from '@contrast-security-inc/design-system-typography'
import { IconHelp } from '@contrast-security-inc/design-system-foundations'
import { css } from '@emotion/css'
import { WithTooltip } from '../../../../design-system'
import { ApplicationField } from './application-field'
import { Box, Row } from '../../../../legacy-design-system/form'
import { ApplicationImportance } from './application-importance'
import { useController } from 'react-hook-form'
import { JiraFormFieldTypes } from './jira-form-field-types'
import { Radio } from '@contrast-security-inc/design-system-inputs'

export const ApplicationsFields: FC = () => {
  const { formatMessage } = useIntl()
  const {
    field: { onChange, value: appCriterion }
  } = useController({ name: JiraFormFieldTypes.APP_CRITERION })

  return (
    <>
      <div
        className={css`
          display: flex;
          flex-direction: column;
          gap: 4px;
        `}
      >
        <div
          className={css`
            display: flex;
            gap: 4px;
          `}
        >
          <Radio
            label={formatMessage({
              id: 'title_applications'
            })}
            isChecked={appCriterion}
            onChange={() => onChange(true)}
            testId="applications-radio"
          />
          <WithTooltip
            tiny
            placement="auto"
            renderTooltipContent={() => (
              <Text font="body">
                {formatMessage({
                  id: 'detail_integrationsSettings_jiraApplications'
                })}
              </Text>
            )}
            children={() => <IconHelp size="sm" color="neutral50" />}
          />
        </div>

        {appCriterion && (
          <Row>
            <Box basis={9}>
              <ApplicationField />
            </Box>
          </Row>
        )}
        <div
          className={css`
            display: flex;
            gap: 4px;
          `}
        >
          <Radio
            label={formatMessage({
              id: 'title_appImportances'
            })}
            isChecked={!appCriterion}
            onChange={() => onChange(false)}
            testId="importance-radio"
          />
          <WithTooltip
            tiny
            placement="auto"
            renderTooltipContent={() => (
              <Text font="body">
                {formatMessage({
                  id: 'detail_integrationsSettings_jiraApplicationImportance'
                })}
              </Text>
            )}
            children={() => <IconHelp size="sm" color="neutral50" />}
          />
        </div>

        {!appCriterion && (
          <Row>
            <Box basis={9}>
              <ApplicationImportance />
            </Box>
          </Row>
        )}
      </div>
    </>
  )
}
